import {Injectable} from '@angular/core';
import { Group } from '@edl-development/edl-common';
import {GroupApi} from '../api/group.api';
@Injectable()
export class GroupService {
    constructor(private groupApi: GroupApi) {

    }

    createGroup = (group: Group) => this.groupApi.createGroup(group);

    getGroupsByPortal = (portalId: number, offset?: number, limit?: number, orderBy?: string, ascending?: boolean, searchBy?: string, baseUrl?: string) =>
        this.groupApi.getGroupsByPortal(portalId, offset, limit, orderBy, ascending, searchBy, baseUrl);

    updateGroup = (group: Group) => this.groupApi.updateGroup(group);

    deleteGroup = (group: Group) => this.groupApi.deleteGroup(group);

    restoreGroup = (group: Group) => this.groupApi.restoreGroup(group);

    removeGroup = (group: Group) => this.groupApi.removeGroup(group);

    getGroupByGroupId = (groupId: number) => this.groupApi.getGroupByGroupId(groupId);

    getAllGroupsForPortal = () => this.groupApi.getAllGroupsForPortal();

    getUserGroupsByPortal = (offset: number, limit: number, searchBy: string, role: string, group: string, building: string) => 
        this.groupApi.getUserGroupsByPortal(offset, limit,  searchBy, role, group, building);

    saveGroupAssignment = (GroupID: string, UserId: any, checked: boolean): any =>
        this.groupApi.saveGroupAssignment(GroupID, UserId,  checked);

    uploadUsersForGroup = (fileList: FileList, groupName:string, groupId: string): any => 
        this.groupApi.uploadUsersForGroup(fileList, groupName, groupId);
}